// Copyright ©️ 2026 eVolve MEP, LLC

import type { ComponentProps } from 'react';

import { Button, type ButtonProps } from '@mantine/core';

import { EvolveIcon } from 'assets/icons/EvolveIcon';

export const EditButton = ({
  editing,
  ...props
}: ButtonProps &
  ComponentProps<typeof Button> & {
    onClick: () => void;
    editing: boolean;
  }) => (
  <Button
    className="edit-description-button"
    size="xs"
    variant="light"
    pos="absolute"
    style={{
      right: 0,
      top: 0,
      borderRadius: 0,
      borderTopWidth: 0,
      borderRightWidth: 0,
      borderBottomLeftRadius: 'var(--mantine-radius-md)',
      opacity: editing ? 0 : 1,
      cursor: editing ? 'initial' : 'pointer',
    }}
    px="xs"
    {...props}
  >
    <EvolveIcon icon="Edit" />
  </Button>
);
